import { useParams, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import { StockLedgerReport } from '@/components/trading/reports/stock-ledger-report';
import { StockStatusReport } from '@/components/trading/reports/stock-status-report';
import { StockTrialBalanceReport } from '@/components/trading/reports/stock-trial-balance-report';
import { ProductProfitLossReport } from '@/components/trading/reports/product-profit-loss-report';

const TABS = [
  { key: 'stock-ledger', labelKey: 'reports.tabLedger', fallback: 'Stok Hareket' },
  { key: 'stock-status', labelKey: 'reports.tabStatus', fallback: 'Stok Durum' },
  { key: 'stock-mizan', labelKey: 'reports.tabMizan', fallback: 'Stok Mizan' },
  { key: 'profit-loss', labelKey: 'reports.tabProfitLoss', fallback: 'Kâr / Zarar' },
] as const;

export function TradingReportsPage() {
  const { t } = useTranslation('trading');
  const { report } = useParams<{ report?: string }>();
  const active = TABS.some((tab) => tab.key === report) ? report! : 'stock-ledger';

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">{t('reports.title', 'Raporlar')}</h1>
        <p className="text-muted-foreground">{t('reports.subtitle', 'Stok ve kâr/zarar raporları')}</p>
      </div>

      <div className="flex items-center gap-1 overflow-x-auto border-b border-border">
        {TABS.map((tab) => (
          <NavLink
            key={tab.key}
            to={`/trading/reports/${tab.key}`}
            className={cn(
              '-mb-px whitespace-nowrap border-b-2 px-4 py-2.5 text-sm font-medium transition-colors',
              active === tab.key
                ? 'border-primary text-primary'
                : 'border-transparent text-muted-foreground hover:text-foreground'
            )}
          >
            {t(tab.labelKey, tab.fallback)}
          </NavLink>
        ))}
      </div>

      {active === 'stock-ledger' && <StockLedgerReport />}
      {active === 'stock-status' && <StockStatusReport />}
      {active === 'stock-mizan' && <StockTrialBalanceReport />}
      {active === 'profit-loss' && <ProductProfitLossReport />}
    </div>
  );
}
